
<div >
    <login-home-navigation></login-home-navigation>
    
</div>

<section class="testimonial-hero">

    <div class="container">

        <span class="page-badge">
            Customer Success Stories
        </span>

       <h1>
    Trusted By Manufacturing
    <br>
    Buyers & Suppliers Across India
</h1>

        <p>
            See how procurement teams and manufacturing companies are creating
            successful business relationships through GYV.
        </p>

    </div>

</section>

<section class="trust-section">

    <div class="container">

        <div class="trust-grid">

            <div class="trust-item">
                <h3>16,000+</h3>
                <span>Suppliers</span>
            </div>

            <div class="trust-item">
                <h3>300+</h3>
                <span>Buyers</span>
            </div>

            <div class="trust-item">
                <h3>3,000+</h3>
                <span>Business Matches</span>
            </div>

            <div class="trust-item">
                <h3>40+</h3>
                <span>Manufacturing Categories</span>
            </div>

        </div>

    </div>

</section>

<section class="testimonials-section">

    <div class="container">

        <div class="section-header">

            <h2>What Our Customers Say</h2>

        </div>

        <div class="row">

            <!-- Card 1 -->

            <div class="col-lg-4">

                <div class="testimonial-card">

                    <img src="assets/images/media/cust3.webp">

                    <h4>Mr. Ankit Patel</h4>

                    <span>Managing Director</span>

                    <p>
                        GYV helped us connect with reliable manufacturing partners and simplify supplier identification.
                    </p>

                </div>

            </div>

            <!-- Card 2 -->

            <div class="col-lg-4">

                <div class="testimonial-card">

                    <img src="assets/images/media/cust1.webp">

                    <h4>S. Surya</h4>

                    <span>Manufacturing Engineer</span>

                    <p>
                        The transparency and technical support provided through the platform made sourcing significantly easier.
                    </p>

                </div>

            </div>

            <!-- Card 3 -->

            <div class="col-lg-4">

                <div class="testimonial-card">

                    <img src="assets/images/media/cust2.webp">

                    <h4>Ashutosh Joshi</h4>

                    <span>Owner</span>

                    <p>
                        The team behind GYV understands manufacturing and consistently delivers genuine opportunities.
                    </p>

                </div>

            </div>

        </div>

    </div>

</section>

<section class="video-testimonials">

    <div class="container">

        <div class="section-header">

            <h2>Video Testimonials</h2>

        </div>

        <div class="row">

            <div class="col-lg-6">

                <div class="video-card">

                    <iframe
                        src="https://www.youtube.com/embed/fS1UiUcPfyg"
                        allowfullscreen>
                    </iframe>

                </div>

            </div>

            <div class="col-lg-6">

                <div class="video-card">

                    <iframe
                        src="https://www.youtube.com/embed/d88eSqutNHE"
                        allowfullscreen>
                    </iframe>

                </div>

            </div>

        </div>

    </div>

</section>

<section class="success-cta">

    <div class="container">

        <h2>
            Ready To Grow With GYV?
        </h2>

        <p>
            Join India's growing manufacturing network and connect with buyers and suppliers across multiple industries.
        </p>

        <a routerLink="/signup" class="cta-btn">
            Create Your Account
        </a>

    </div>

</section>



<login-home-footer></login-home-footer>
